module.exports = __webpack_public_path__ + "static/media/icon-dismissal-x.d0af405b.svg";